"use client";

import Breadcrumb from "@/components/Common/Breadcrumb";
import { getImagePath } from "@/lib/utils";
import { useTranslations } from "next-intl";

const Page = () => {
  const t = useTranslations("familySafeEntertainment");

  return (
    <section className="section-padding bg-white py-16 md:py-24">
      <Breadcrumb
        pageName={t("pageName")}
        description=""
        bgImages={[getImagePath("/images/breadcrumb/joinPartner.webp")]}
        bgIndex={0}
      />

      <div className="container mx-auto px-4 py-10 text-gray-700 text-lg leading-relaxed">
        <h2 className="text-[#A23465] text-2xl font-bold">
          {t("why_title")}
        </h2>
        <p>{t("why_p1")}</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10 w-full p-0 text-center mx-auto">
          <div className="space-y-5">
            <div className="mx-auto px-4 py-10 text-gray-700 text-lg leading-relaxed text-right">
              <h2 className="text-[#A23465] text-2xl font-bold">
                {t("cultural_title")}
              </h2>
              <p>{t("cultural_p")}</p>
            </div>

            <div className="mx-auto px-2 py-5 text-gray-700 text-lg leading-relaxed text-right">
              <h2 className="text-[#A23465] text-2xl font-bold">
                {t("empower_title")}
              </h2>
              <p>{t("empower_p")}</p>
            </div>
          </div>

          <div className="space-y-5">
            <div className="mx-auto px-4 py-10">
              <img
                src={getImagePath("/images/about/familiSef.png")}
                alt="Family Safe Entertainment"
                className="w-full h-auto rounded-lg"
              />
            </div>

            <div className="mx-auto px-2 py-5 text-gray-700 text-lg leading-relaxed text-center">
              <h2 className="text-[#A23465] text-2xl font-bold">
                {t("versatility_title")}
              </h2>
              <p>{t("versatility_p")}</p>
            </div>
          </div>

          <div className="space-y-5">
            <div className="mx-auto px-4 py-10 text-gray-700 text-lg leading-relaxed text-left">
              <h2 className="text-[#A23465] text-2xl font-bold">
                {t("competition_title")}
              </h2>
              <p>{t("competition_p")}</p>
            </div>

            <div className="mx-auto px-2 py-5 text-gray-700 text-lg leading-relaxed text-left">
              <h2 className="text-[#A23465] text-2xl font-bold">
                {t("market_title")}
              </h2>
              <p>{t("market_p")}</p>
            </div>
          </div>
        </div>

        <div
          className="mx-auto px-10 py-10 text-white text-lg leading-relaxed text-center rounded-tl-[45px] rounded-br-[40px] mt-16"
          style={{
            backgroundImage: `url('${getImagePath("/images/about/PossibleImprovements.png")}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <h2 className="text-white text-2xl font-bold">
            {t("improve_title")}
          </h2>
          <p className="text-white">{t("improve_p1")}</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-10 text-left mx-auto md:py-10 md:px-10">
            <div className="quote-box mt-5 p-4 border-l-4 border-primary">
              <h2 className="font-bold">{t("improve_lang_title")}</h2>
              <p className="text-white">{t("improve_lang_p")}</p>
            </div>

            <div className="quote-box mt-5 p-4 border-l-4 border-primary">
              <h2 className="font-bold">{t("improve_sensitivity_title")}</h2>
              <p className="text-white">{t("improve_sensitivity_p")}</p>
            </div>

            <div className="quote-box mt-5 p-4 border-l-4 border-primary">
              <h2 className="font-bold">{t("improve_transparency_title")}</h2>
              <p className="text-white">{t("improve_transparency_p")}</p>
            </div>
          </div>
        </div>

        <h2 className="text-[#A23465] text-2xl font-bold mt-10">
          {t("summary_title")}
        </h2>
        <p>{t("summary_p")}</p>
      </div>
    </section>
  );
};

export default Page;

